import { NavigationExtras } from '@angular/router';
import { RouteInjection } from '../../shared/routing/route-injection.class';

export class LvrRedirectNav extends RouteInjection {
	protected redirectUrl = this.resolveParamAsSignal<string>('redirectUrl');

	/**
	 * This methods handles navigation after finishing an action. If a redirect URL is provided via query parameter,
	 * it navigates to that URL. Otherwise, it uses the provided default commands and extras.
	 * @param defaultCommands default route if no redirect url is provided
	 * @param extras additional navigation info if no redirect url is provided
	 */
	protected navigateAfterFinished(defaultCommands: unknown[], extras?: NavigationExtras): Promise<boolean> {
		const redirectUrl = this.redirectUrl();
		if (redirectUrl) {
			return this.router.navigateByUrl(redirectUrl);
		}
		return this.router.navigate(defaultCommands, extras);
	}
}
